import React from 'react';
import { Helmet } from 'react-helmet';
import Contact from '../components/Contact';
import BreadcrumbSchema from '../components/BreadcrumbSchema';

const ContactoPage = () => {
  return (
    <>
      <Helmet>
        <title>Contacto | GENSOL - Solicita tu Cotización de Generadores</title>
        <meta name="description" content="Contacta a GENSOL para cotizar renta de generadores eléctricos en Veracruz. Teléfono: 229 921 23 32. WhatsApp: 229 207 2733. Respuesta en menos de 24 horas." />
        <meta name="keywords" content="contacto GENSOL, cotización generadores, teléfono GENSOL Veracruz, renta equipos eléctricos" />
        <link rel="canonical" href="https://www.gensolver.com/contacto" />
        <meta property="og:title" content="Contacto | GENSOL Veracruz" />
        <meta property="og:description" content="Solicita tu cotización. Respuesta en menos de 24 horas." />
        <meta property="og:url" content="https://www.gensolver.com/contacto" />
      </Helmet>

      <BreadcrumbSchema
        items={[
          { name: 'Inicio', url: 'https://www.gensolver.com/' },
          { name: 'Contacto', url: 'https://www.gensolver.com/contacto' },
        ]}
      />

      <main id="contacto-page" data-page="contacto" data-analytics-page="contacto" className="pt-24">
        {/* Contact Info Banner */}
        <section className="py-12 bg-gray-200">
          <div className="container mx-auto px-4">
            <div className="text-center mb-8">
              <h1 className="text-4xl md:text-5xl font-bold text-black mb-4">
                <span className="text-orange-500">Contáctanos</span>
              </h1>
              <p className="text-gray-800 max-w-2xl mx-auto">
                Estamos listos para ayudarte con tu proyecto. Respuesta garantizada en menos de 24 horas.
              </p>
            </div>

            {/* Quick Contact Cards */}
            <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto mb-12">
              <a 
                href="tel:+522299212332"
                data-testid="contact-phone-card"
                data-analytics-click="contact-page-phone"
                className="bg-white p-6 rounded-xl border border-gray-200 hover:border-orange-500 transition-all text-center group"
              >
                <div className="w-14 h-14 bg-orange-500/20 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-orange-500 transition-colors">
                  <svg className="w-7 h-7 text-orange-500 group-hover:text-gray-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <h3 className="text-gray-900 font-bold mb-1">Teléfono</h3>
                <p className="text-orange-500 font-semibold">229 921 23 32</p>
              </a>

              <a 
                href="https://wa.me/522292072733"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-card"
                data-analytics-click="contact-page-whatsapp"
                className="bg-white p-6 rounded-xl border border-gray-200 hover:border-green-500 transition-all text-center group"
              >
                <div className="w-14 h-14 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-green-500 transition-colors">
                  <svg className="w-7 h-7 text-green-500 group-hover:text-gray-900" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                </div>
                <h3 className="text-gray-900 font-bold mb-1">WhatsApp</h3>
                <p className="text-green-500 font-semibold">229 207 2733</p>
              </a>

              <a 
                href="mailto:gensolnr@gensolver.com"
                data-testid="contact-email-card"
                data-analytics-click="contact-page-email"
                className="bg-white p-6 rounded-xl border border-gray-200 hover:border-orange-500 transition-all text-center group"
              >
                <div className="w-14 h-14 bg-orange-500/20 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-orange-500 transition-colors">
                  <svg className="w-7 h-7 text-orange-500 group-hover:text-gray-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <h3 className="text-gray-900 font-bold mb-1">Email</h3>
                <p className="text-orange-500 font-semibold text-sm">contacto@gensolver.com</p>
              </a>
            </div>

            {/* Emergency Banner */}
            <div 
              className="bg-red-50 border border-red-500/50 rounded-xl p-6 max-w-2xl mx-auto text-center"
              data-analytics-element="emergency-banner"
            >
              <h3 className="text-red-700 font-bold text-lg mb-2">
                ¿Emergencia Eléctrica?
              </h3>
              <p className="text-gray-800 mb-3">
                Línea de emergencias disponible 24/7
              </p>
              <a 
                href="tel:+522292935482"
                data-testid="contact-emergency-btn"
                data-analytics-click="contact-page-emergency"
                className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-bold transition-all"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
                +52 229 293 5482
              </a>
            </div>
          </div>
        </section>

        <Contact />

        {/* Map/Location Section */}
        <section className="py-16 bg-gray-200">
          <div className="container mx-auto px-4">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Área de <span className="text-orange-500">Cobertura</span>
              </h2>
              <p className="text-gray-600">
                Servicio en todo el sureste de México
              </p>
            </div>
            <div 
              className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto"
              data-analytics-element="coverage-area"
            >
              {['Veracruz', 'Tabasco', 'Chiapas', 'Campeche', 'Yucatán', 'Quintana Roo', 'Puebla', 'Oaxaca'].map((state) => (
                <div key={state} className="bg-white px-4 py-3 rounded-lg text-center border border-gray-200">
                  <span className="text-gray-900">{state}</span>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default ContactoPage;
